export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `سياسة الخصوصية`,
    cloneTitleNoun: `سياسات مكان الإقامة`,
    cloneItemNoun: `السياسات`,
    editorHintLang: `سياسة الخصوصية بلغة {label}`,
    optional: `(اختياري)`,
    headingOpt1: `عنوان 1`,
    headingOpt2: `عنوان 2`,
    headingOpt3: `عنوان 3`,
    headingNormal: `عادي`,
    tipBold: `عريض`,
    tipItalic: `مائل`,
    tipUnderline: `تسطير`,
    tipListOrdered: `قائمة مرتبة`,
    tipListBullet: `قائمة نقطية`,
    tipLink: `رابط`,
    tipQuote: `اقتباس`,
    tipClean: `مسح التنسيق`,
    charCount: `{count} حرف | {count} حرف`,
    saving: `جارٍ الحفظ…`,
    editorPlaceholder: `اكتب هنا سياسة الخصوصية بلغة {label}…`,
    errNoListing: `لم يتم العثور على القائمة.`,
    errLoad: `تعذّر تحميل سياسة الخصوصية.`,
    errEsRequired: `السياسة باللغة الإسبانية مطلوبة.`,
    saveSuccess: `تم حفظ سياسة الخصوصية بنجاح.`,
    saveError: `حدث خطأ أثناء حفظ السياسات.`,
  },
  rooms: {
    bulkTitle: `إنشاء الغرف بالجملة`,
    bulkSubtitle: `أنشئ عدة غرف لنوع واحد، برمز تلقائي ووصف اختياري.`,
    available: `متاح: {count}`,
    willCreate: `سيتم إنشاء: {count}`,
    needTypeFirst: `أنشئ أولًا <b>نوع غرفة</b> واحدًا على الأقل حتى تتمكن من توليد الغرف.`,
    labelType: `النوع`,
    selectType: `اختر نوعًا`,
    labelQuantity: `الكمية`,
    phQuantity: `مثال: 10`,
    labelPrefix: `بادئة الرمز`,
    phPrefix: `مثال: A- أو 10`,
    optional: `اختياري`,
    labelStart: `البداية`,
    labelPadding: `التعبئة`,
    labelDescription: `الوصف (اختياري)`,
    phDescription: `سيُطبَّق على الغرف المُنشأة`,
    nameEqType: `الاسم = النوع`,
    recommended: `(موصى به)`,
    example: `مثال:`,
    createBulk: `إنشاء بالجملة`,
    typeFallback: `النوع`,
    previewFormat: `{name} • الرمز: {code}`,
    noActivePlan: `ليس لديك خطة نشطة لإنشاء الغرف.`,
    limitReached: `تم بلوغ الحد: تسمح خطتك بـ {limit} غرفة لهذا العقار.`,
    selectTypeWarn: `اختر نوع غرفة.`,
    invalidQuantity: `أدخل كمية صحيحة.`,
    cannotAddMore: `لا يمكنك إضافة المزيد. الحد: {limit}.`,
    partialCreated: `تم إنشاء {created} فقط لأن خطتك تسمح بـ {limit} وتبقّى لديك {remaining}.`,
    planLimitSave: `تسمح خطتك بـ {limit} غرفة. أنت تحاول حفظ {count}.`,
  },
  images: {
    zipDownloadTitle: `تنزيل جميع صور العقار في ملف ZIP`,
    zipNoImages: `لا توجد صور للتنزيل`,
    preparing: `جارٍ التحضير…`,
    downloadImages: `تنزيل الصور`,
    loading: `جارٍ تحميل الصور…`,
    noAccommodations: `لم يتم إعداد أي أماكن إقامة لهذا العقار بعد.`,
    engineCoverTag: `غلاف المحرك`,
    imageCount: `{count} صورة | {count} صورة`,
    hotelPhotosDesc: `صور عامة (الفناء، المدخل، الاستقبال…) سيراها العميل عند فتح المحرك`,
    dragToOrder: `اسحب لترتيب المعرض`,
    ordering: `جارٍ الترتيب…`,
    dragTip: `سحب`,
    hotelSectionName: `صور الفندق · المناطق المشتركة`,
    orderUpdated: `تم تحديث ترتيب الصور.`,
    orderError: `تعذّر تحديث ترتيب الصور.`,
    downloadError: `تعذّر تنزيل الصور.`,
  },
};
